"use client";
import type { Destinations as DestinationsData } from "@/queries/getDestinations";
import { useStore } from "@nanostores/react";
import { usePathname } from "next/navigation";
import { type ReactNode, useState } from "react";
import { SearchBar } from "../search/searchbar";
import { ContainerHomepage } from "./ContainerHomepage";
import { ContainerRest } from "./ContainerRest";
import { HeaderInner } from "./HeaderInner";
import { menuStore } from "./MenuInner";
import { disabledSearchBarPageList } from "./disabledSearchBarPageList";

type Props = {
  infoHeader: ReactNode;
  basket: ReactNode;
  catalogueImage: ReactNode;
  destinations: DestinationsData;
  menuThemeCards: ReactNode;
};
export const Header = ({ infoHeader, basket, destinations, catalogueImage, menuThemeCards }: Props) => {
  const pathname = usePathname();
  const isTransparentHeaderPage =
    pathname === "/" ||
    pathname === "/calendrier-avent-2025/" ||
    pathname === "/entreprise/qui-sommes-nous/" ||
    pathname === "/sur-mesure/individuel/" ||
    /^\/sur-mesure\/individuel\/voyage\//.test(pathname);
  const [isHeaderTransparent, setIsHeaderTransparent] = useState(isTransparentHeaderPage);
  const openMenu = useStore(menuStore);

  const isReallyTransparent = isHeaderTransparent && openMenu === null;

  const isSearchBarDisabled = disabledSearchBarPageList.some((page) => page.test(pathname));

  if (isTransparentHeaderPage) {
    return (
      <ContainerHomepage
        infoHeader={infoHeader}
        search={isSearchBarDisabled ? null : <SearchBar />}
        isHeaderTransparent={isReallyTransparent}
        setIsHeaderTransparent={setIsHeaderTransparent}
      >
        <HeaderInner
          basket={basket}
          destinations={destinations}
          isHeaderTransparent={isReallyTransparent}
          catalogueImage={catalogueImage}
          menuThemeCards={menuThemeCards}
          isHomepage
        />
      </ContainerHomepage>
    );
  }

  return (
    <ContainerRest infoHeader={infoHeader} search={<SearchBar />}>
      <HeaderInner
        basket={basket}
        destinations={destinations}
        isHeaderTransparent={false}
        catalogueImage={catalogueImage}
        menuThemeCards={menuThemeCards}
      />
    </ContainerRest>
  );
};
